import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './TopFold.css';
import logo512 from '../assets/images/logo512.png';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Footer from './Footer';
import Banner from '../components/Banner';
import TopicNav from '../components/TopicNav';
import ExpertsList from '../components/ExpertsList';

const SEARCH_CATEGORIES = [
  { label: 'Skills' },
  { label: 'Mentorship' },
  { label: 'Experiences' },
  { label: 'Workshops' },
  { label: 'Events' },
  { label: 'Wellness' },
  { label: 'Networking' },
  { label: 'Q&A Sessions' },
  { label: 'Community' },
  { label: 'Collaboration' },
  { label: 'Support' },
  { label: 'Consulting' },
];

const USER_MENU_ITEMS = [
  { label: 'Gift cards', bold: false },
  { label: 'Become an expert', bold: false },
  { label: 'How it works', bold: false },
  { label: 'Help Centre', bold: false },
];
const LANGUAGES = [
  'English',
  'Français',
  'Español',
];

const TopFold = () => {
  const [selectedOption, setSelectedOption] = useState(SEARCH_CATEGORIES[0].label);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [date, setDate] = useState(null);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [langMenuOpen, setLangMenuOpen] = useState(false);
  const [activeTopic, setActiveTopic] = useState('trending');
  const userMenuRef = useRef();
  const langMenuRef = useRef();
  const dropdownRef = useRef();
  const navigate = useNavigate();

  const handleTopicChange = (topicId) => {
    setActiveTopic(topicId);
  };

  // Close dropdowns on outside click
  useEffect(() => {
    function handleClick(e) {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
      if (langMenuRef.current && !langMenuRef.current.contains(e.target)) {
        setLangMenuOpen(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <header className="topfold">
      <Banner />
      {/* Navbar */}
      <nav className="topfold-navbar">
        <div className="topfold-logo-wrap">
          <img src={logo512} alt="Logo" className="topfold-logo" />
        </div>
        <ul className="topfold-nav-links">
          <li>Home</li>
          <li>Explore</li>
          <li>Learn</li>
          <li>Experience</li>
          <li>About</li>
        </ul>
        <div className="topfold-icons">
          {/* Help word */}
          <span className="topfold-help">Help</span>
          {/* Globe Icon for language selector */}
          <div className="dropdown-wrap" ref={langMenuRef}>
            <button className="globe-btn" aria-label="Select language" onClick={() => setLangMenuOpen(v => !v)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="#222" strokeWidth="2"/><path d="M2 12h20M12 2c2.5 2.5 4 6.5 4 10s-1.5 7.5-4 10c-2.5-2.5-4-6.5-4-10s1.5-7.5 4-10z" stroke="#222" strokeWidth="2"/></svg>
            </button>
            <div className={`dropdown-menu-animated${langMenuOpen ? ' open' : ''}`}> 
              {LANGUAGES.map(lang => (
                <div className="dropdown-menu-item" key={lang}>{lang}</div>
              ))}
            </div>
          </div>
          {/* User menu button: menu lines first, then user icon, larger bubble */}
          <div className="dropdown-wrap" ref={userMenuRef}>
            <button className="user-menu-btn" aria-label="User menu" onClick={() => setUserMenuOpen(v => !v)}>
              <span className="user-menu-lines">
                <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect y="4" width="18" height="2" rx="1" fill="#444"/>
                  <rect y="8" width="18" height="2" rx="1" fill="#444"/>
                  <rect y="12" width="18" height="2" rx="1" fill="#444"/>
                </svg>
              </span>
              <span className="user-menu-icon-bg">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
                  <circle cx="16" cy="16" r="16" fill="#6c36f8"/>
                  <circle cx="16" cy="13" r="6" fill="#fff"/>
                  <ellipse cx="16" cy="23" rx="10" ry="5" fill="#fff"/>
                </svg>
              </span>
            </button>
            <div className={`dropdown-menu-animated${userMenuOpen ? ' open' : ''}`}>
              {USER_MENU_ITEMS.map((item, i) => {
                if (item.divider) {
                  return <div className="dropdown-divider" key={i}></div>;
                }
                
                return (
                  <div 
                    className={`dropdown-menu-item${item.bold ? ' bold' : ''}`} 
                    key={item.label}
                  >
                    {item.label}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="topfold-hero">
        <h1 className="topfold-title">
          The Future of Learning isn't a Classroom
        </h1>
        {/* Search Bar */}
        <div className="topfold-searchbar wide-searchbar">
          <div className={`custom-dropdown${dropdownOpen ? ' open' : ''}`} ref={dropdownRef}
               tabIndex={0}
               onClick={() => setDropdownOpen(!dropdownOpen)}
               onBlur={() => setDropdownOpen(false)}>
            <span className="dropdown-label">{selectedOption}</span>
            <span className="dropdown-arrow">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 7.5L9 12L13.5 7.5" stroke="#444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
            {dropdownOpen && (
              <div className="dropdown-menu-animated open search-dropdown-menu limited-height">
                {SEARCH_CATEGORIES.map(cat => (
                  <div key={cat.label} className="dropdown-menu-item search-category-item" onClick={() => { setSelectedOption(cat.label); setDropdownOpen(false); }}>
                    <span className="search-category-label">{cat.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <input
            className="topfold-search-input"
            type="text"
            placeholder="Try gardening, racing, cooking..."
          />
          <div className="datepicker-wrap">
            <DatePicker
              selected={date}
              onChange={setDate}
              placeholderText="Any date"
              className="topfold-search-date"
              calendarClassName="custom-calendar"
              popperPlacement="bottom"
            />
          </div>
          <button className="topfold-search-btn">Search</button>
        </div>
        {/* Links */}
        <div className="topfold-links">
          <button 
            className="expert-button"
            onClick={() => navigate('/browse-experts')}
          >
            Browse Experts →
          </button>
          <button 
            className="expert-button"
            onClick={() => navigate('/become-expert')}
          >
            Become an Expert →
          </button>
        </div>
      </div>

      {/* Features Grid Section */}
      <div className="topfold-features">
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M16 2L4 8V24L16 30L28 24V8L16 2Z" stroke="#6f00ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15Z" stroke="#6f00ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M22 21C22 18.2386 19.3137 16 16 16C12.6863 16 10 18.2386 10 21" stroke="#6f00ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Expert-Led Learning</h3>
            <p>Connect with industry leaders and learn from their real-world experience</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z" stroke="#6f00ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 16L15 19L20 13" stroke="#6f00ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Verified Quality</h3>
            <p>Every expert is thoroughly vetted to ensure top-tier knowledge sharing</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M4 11L16 5L28 11L16 17L4 11Z" stroke="#6f00ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M28 16L16 22L4 16" stroke="#6f00ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M28 21L16 27L4 21" stroke="#6f00ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Flexible Learning</h3>
            <p>Choose from various formats: 1-on-1 sessions, workshops, or group experiences</p>
          </div>
        </div>
      </div>

      {/* Experts Section */}
      <div className="topfold-experts">
        <TopicNav onTopicChange={handleTopicChange} />
        <ExpertsList activeTopic={activeTopic} />
      </div>

      {/* Benefits Section */}
      <div className="topfold-benefits">
        <div className="benefit-content">
          <h2>Transform Your Journey</h2>
          <p className="benefit-subtitle">Whether you're starting out or leveling up, find the perfect mentor to guide your path</p>
          
          <div className="benefit-stats">
            <div className="stat-item">
              <span className="stat-number">50K+</span>
              <span className="stat-label">Active Experts</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">1M+</span>
              <span className="stat-label">Learners</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">98%</span>
              <span className="stat-label">Satisfaction</span>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="topfold-cta">
        <div className="cta-content">
          <h2>Ready to Share Your Expertise?</h2>
          <p>Join our community of experts and help others grow while earning on your own terms</p>
          <button className="cta-button">Become an Expert</button>
          <span className="cta-subtitle">No commitment required • Set your own schedule</span>
        </div>
      </div>

      <Footer />
    </header>
  );
};

export default TopFold; 